import {RootState} from "../../../../store/rootReducer";

export const extraActionsMenuSelector = (state: RootState) => ({
   isMenuOpen: state.cardView.isSideMenuOpen,
   isReverting: state.cardView.isReverting,
});
